"use client";

import React, { useState } from "react";
import Link from "next/link";
import AdmissionEnquiryModal from "./AdmissionEnquiryModal";

const countries = [
  {
    name: "China",
    slug: "china",
    flag: "🇨🇳",
    flagCode: "cn",
    alt: "Study in China",
  },
  {
    name: "Vietnam",
    slug: "vietnam",
    flag: "🇻🇳",
    flagCode: "vn",
    alt: "Study in Vietnam",
  },
  {
    name: "Philippines",
    slug: "philippines",
    flag: "🇵🇭",
    flagCode: "ph",
    alt: "Study in Philippines",
  },
  {
    name: "New Zealand",
    slug: "new-zealand",
    flag: "🇳🇿",
    flagCode: "nz",
    alt: "Study in New Zealand",
  },
  {
    name: "Bangladesh",
    slug: "bangladesh",
    flag: "🇧🇩",
    flagCode: "bd",
    alt: "Study in Bangladesh",
  },
  {
    name: "Kazakhstan",
    slug: "kazakhstan",
    flag: "🇰🇿",
    flagCode: "kz",
    alt: "Study in Kazakhstan",
  },
  {
    name: "Kyrgyzstan",
    slug: "kyrgyzstan",
    flag: "🇰🇬",
    flagCode: "kg",
    alt: "Study in Kyrgyzstan",
  },
  {
    name: "United States",
    slug: "united-states",
    flag: "🇺🇸",
    flagCode: "us",
    alt: "Study in United States",
  },
  {
    name: "United Kingdom",
    slug: "united-kingdom",
    flag: "🇬🇧",
    flagCode: "gb",
    alt: "Study in United Kingdom",
  },
  {
    name: "UAE",
    slug: "uae",
    flag: "🇦🇪",
    flagCode: "ae",
    alt: "Study in UAE",
  },
  {
    name: "Luxembourg",
    slug: "luxembourg",
    flag: "🇱🇺",
    flagCode: "lu",
    alt: "Study in Luxembourg",
  },
  {
    name: "Japan",
    slug: "japan",
    flag: "🇯🇵",
    flagCode: "jp",
    alt: "Study in Japan",
  },
  {
    name: "Germany",
    slug: "germany",
    flag: "🇩🇪",
    flagCode: "de",
    alt: "Study in Germany",
  },
  {
    name: "Netherlands",
    slug: "netherlands",
    flag: "🇳🇱",
    flagCode: "nl",
    alt: "Study in Netherlands",
  },
  {
    name: "Ireland",
    slug: "ireland",
    flag: "🇮🇪",
    flagCode: "ie",
    alt: "Study in Ireland",
  },
  {
    name: "Belarus",
    slug: "belarus",
    flag: "🇧🇾",
    flagCode: "by",
    alt: "Study in Belarus",
  },
  {
    name: "Australia",
    slug: "australia",
    flag: "🇦🇺",
    flagCode: "au",
    alt: "Study in Australia",
  },
  {
    name: "Canada",
    slug: "canada",
    flag: "🇨🇦",
    flagCode: "ca",
    alt: "Study in Canada",
  },
  {
    name: "Russia",
    slug: "russia",
    flag: "🇷🇺",
    flagCode: "ru",
    alt: "Study in Russia",
  },
  {
    name: "Georgia",
    slug: "georgia",
    flag: "🇬🇪",
    flagCode: "ge",
    alt: "Study in Georgia",
  },
  {
    name: "Uzbekistan",
    slug: "uzbekistan",
    flag: "🇺🇿",
    flagCode: "uz",
    alt: "Study in Uzbekistan",
  },
  {
    name: "Malaysia",
    slug: "malaysia",
    flag: "🇲🇾",
    flagCode: "my",
    alt: "Study in Malaysia",
  },
  {
    name: "Nepal",
    slug: "nepal",
    flag: "🇳🇵",
    flagCode: "np",
    alt: "Study in Nepal",
  },
];

const CountryCard = ({ country }) => {
  const [hovered, setHovered] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="country-card flex flex-col items-center px-4">
      <Link
        href={`/mbbs-in-${country.slug}`}
        className="text-inherit"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <figure className="m-0 flex cursor-pointer flex-col items-center gap-3">
          <div
            aria-label={country.alt}
            role="img"
            className={`relative flex h-20 w-20 items-center justify-center overflow-hidden rounded-full border-4 border-white bg-white transition-shadow sm:h-24 sm:w-24 ${
              hovered ? "shadow-2xl" : "shadow-md"
            }`}
            style={{
              animation: hovered ? "flagSpin 0.6s ease-in-out 1" : "none",
            }}
          >
            {!imageError ? (
              <img
                src={`https://flagcdn.com/w160/${country.flagCode}.png`}
                alt={country.alt}
                loading="lazy"
                className="h-full w-full rounded-full object-cover"
                onError={() => setImageError(true)}
              />
            ) : (
              <span
                className="flex h-full w-full items-center justify-center leading-none"
                style={{
                  fontSize: "40px",
                  transform: "scale(1.18)",
                  fontFamily:
                    '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "Twemoji Mozilla", sans-serif',
                }}
              >
                {country.flag}
              </span>
            )}
          </div>

          <figcaption
            className={`text-center text-sm font-semibold leading-snug transition-colors sm:text-base ${
              hovered ? "text-[#ff9245]" : "text-slate-900"
            }`}
          >
            {country.name}
          </figcaption>
        </figure>
      </Link>
    </div>
  );
};

const LikeStudy = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    country: "All Countries",
  });

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleOpen = () => {
    setForm({
      name: "",
      email: "",
      phone: "",
      country: "All Countries",
    });
    setMessage("");
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setMessage("");
  };

  const handleSubmit = async () => {
    setSubmitting(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 800));
      setMessage("Your enquiry has been received.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="bg-gray-50 py-12 sm:py-16">
      <style jsx global>{`
        @keyframes flagSpin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        /* Mobile: 425px and below */
        @media (max-width: 425px) {
          .countries-wrapper {
            display: grid !important;
            grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
            gap: 24px 6px !important;
            justify-items: center !important;
            align-items: start !important;
          }

          .country-card {
            width: 100% !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
          }

          .country-card a {
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
          }

          .country-card figure {
            gap: 8px !important;
          }

          .country-card figcaption {
            max-width: 95px !important;
            min-height: 36px !important;
            line-height: 1.2 !important;
          }
        }

        /* Tablet: 426px to 768px */
        @media (min-width: 426px) and (max-width: 768px) {
          .countries-wrapper {
            display: grid !important;
            grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
            gap: 28px 12px !important;
            justify-items: center !important;
            align-items: start !important;
          }

          .country-card {
            width: 100% !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
          }

          .country-card a {
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
          }

          .country-card figure {
            gap: 10px !important;
          }

          .country-card figcaption {
            max-width: 120px !important;
            min-height: 38px !important;
            line-height: 1.2 !important;
          }
        }
      `}</style>

      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <h2 className="mb-8 text-center text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
          Where would you{" "}
          <span className="text-[#ff9245]">like to study?</span>
        </h2>

        <div className="countries-wrapper flex flex-wrap items-start justify-center gap-6">
          {countries.map((country) => (
            <CountryCard key={country.slug} country={country} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            href="/study-abroad-countries"
            className="inline-flex items-center gap-2 rounded-full border-2 border-[#ff9245] px-6 py-2 text-sm font-semibold text-[#ff9245] transition-shadow hover:bg-[#ff9245] hover:text-white"
            onClick={(e) => {
              e.preventDefault();
              handleOpen();
            }}
          >
            View All <i className="mk-arrow-right fs-1-1 fw-700"></i>
          </Link>
        </div>
      </div>

      <AdmissionEnquiryModal
        open={modalOpen}
        onClose={handleClose}
        form={form}
        setForm={setForm}
        onSubmit={handleSubmit}
        submitting={submitting}
        message={message}
      />
    </section>
  );
};

export default LikeStudy;